export class BaseCategory {
    get name() {
        return "Base Category";
    }

    get icon() {
        return null;
    }

    get description() {
        return "";
    }

    get slideTypes() {
        return [];
    }

    getPrompt(options = {}) {
        return "";
    }

    getPromptSchema(options = {}) {
        return {};
    }

    getModelHints() {
        return {};
    }

    getImagePrompt() {
        return null;
        // return "Optionally and if appropriate, you can also suggest a prompt for generating an image to use on the slide. The image should be a single subject or abstract concept related to the topic of the slide. There should be no text in the image.";
    }

    getSlideModels(model) {

    }

    validateGeneratedModel(model, atteptsMade, maxAttempts, contextUsed) {
        return true;
    }

    validateArray(arr) {
        return arr && Array.isArray(arr) && arr.length > 0;
    }

    buildModels(builders) {
        const safeBuilders = Array.isArray(builders) ? builders.filter(Boolean) : [];
        if (safeBuilders.length === 0) {
            return [];
        }

        // map to models with builder set to isFirstChoice sorted into first position
        let models = safeBuilders.sort((a, b) => {
            if (a.isFirstChoice) return -1;
            if (b.isFirstChoice) return 1;
            return 0;
        }).map(builder => builder.model);

        return models;
    }

    getItemListSchema(options = {}) {
        if (options.preserveExactText) {
            return [{
                title: "the exact primary text provided for the item",
                description: "the exact secondary text provided for the item or leave empty if none",
                icon: "keywords for an icon to represent the item",
            }];
        } else {
            return [{
                title: "either a short title or a bullet point",
                // subbullets: [{ text: "string" }],
                description: "an optional short description or explanation for the item",
                icon: "keywords for an icon to represent the item",
            }];
        }
    }

    getConclusionSchema(options = {}) {
        if (options.preserveExactText) {
            return {
                conclusion: "Optionally, if the userinput includes a conclusion, footnote, or takeaway for the slide, include it verbatim here. Otherwise, leave blank. Do not use the visual idea as content."
            };
        } else {
            return {
                // userInputConclusion: "the original user input's conclusion, footnote, or takeaway for the slide, if any",
                conclusion: "Optionally, if the userinput includes a footnote, or takeaway for the slide, rewrite it here. Otherwise, leave blank. Do not use the visual idea as content.",
                // conclusion: "Optionally, if the userinput specifically describes a conclusion, footnote, or takeaway then write a concise, useful conclusion statement here. Otherwise, leave blank."
                // conclusion: "If the userinput contains a final summary, conclusion, or explicit takeaway statement, **you must rephrase and synthesize that content into one concise, polished statement (max 1-2 sentences)**. IN ALL OTHER CASES, YOU MUST RETURN THIS FIELD AS AN EMPTY STRING. Do not infer or synthesize a conclusion from the main body points."
            };
        }
    }
}

